"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import { Globe, Scaling, Network, Activity, Zap, ShieldCheck, HeartPulse, Server } from "lucide-react";
import { CAPABILITY_PANEL } from "@/lib/utils/capabilityWeb.utils";
import CapabilityStatusTile from "./CapabilityStatusTile";

// Anchored to an edge and bled well past it, so the outer chunk of each tile is
// clipped by the panel while the rest reads normally. `flip` puts the icon +
// label on the visible side (left-anchored tiles show their content on the
// right, right-anchored on the left). The label rides bigger now and truncates
// with an ellipsis where it meets the clip.
const RIGHT = "ml-auto w-[112%] -mr-8";
const LEFT = "mr-auto w-[112%] -ml-8";
const FEED = [{
  icon: Globe,
  label: "Served from a global CDN near every visitor",
  cls: RIGHT,
  flip: false
}, {
  icon: Scaling,
  label: "Scales up the moment traffic starts to spike",
  cls: LEFT,
  flip: true
}, {
  icon: Network,
  label: "Traffic balanced across servers so none of them buckle",
  cls: RIGHT,
  flip: false
}, {
  icon: Activity,
  label: "Live monitoring watching every request around the clock",
  cls: LEFT,
  flip: true
}, {
  icon: Zap,
  label: "Cached at the edge so pages load instantly worldwide",
  cls: RIGHT,
  flip: false
}, {
  icon: ShieldCheck,
  label: "DDoS protection filters malicious traffic before it lands",
  cls: LEFT,
  flip: true
}, {
  icon: HeartPulse,
  label: "Automated health checks catch issues before anyone notices",
  cls: RIGHT,
  flip: false
}, {
  icon: Server,
  label: "Instant failover to a backup if a server drops",
  cls: LEFT,
  flip: true
}];
const CapabilityUptimeFeed = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={`${CAPABILITY_PANEL} relative h-44 overflow-hidden p-4`}><motion.div className="space-y-3" animate={{
        y: ["0%", "-50%"]
      }} transition={{
        duration: 11,
        repeat: Infinity,
        ease: "linear"
      }}>{[...FEED, ...FEED].map(_temp)}</motion.div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default CapabilityUptimeFeed;
function _temp(t, idx) {
  return <CapabilityStatusTile key={idx} icon={t.icon} label={t.label} className={t.cls} flip={t.flip} />;
}